import axios from "axios"
import qs from "qs"
import ApiService from "./ApiService"

class OrganizationsApiService extends ApiService {
	static async getCaseStatus(organizationId, caseStatusQuery) {
		const query = qs.stringify({
			query: caseStatusQuery
		})
		const response = await fetch(
			`${super.getBaseUrl()}/organizations/${organizationId}/casestatuses?${query}`
		)
		return await response.json()
	}

	static async getOrganization(organizationId) {
		const { data } = await axios.get(`${super.getBaseUrl()}/organizations/${organizationId}`)
		return data
	}

	static async getOrganizations() {
		const response = await fetch(`${super.getBaseUrl()}/organizations`)
		return await response.json()
	}

	static async getRegistries(organizationId, page = 0) {
		const query = qs.stringify({
			page
		})
		const response = await fetch(
			`${super.getBaseUrl()}/organizations/${organizationId}/registries?${query}`
		)
		return await response.json()
	}
}

export default OrganizationsApiService



// WEBPACK FOOTER //
// ./src/api/OrganizationsApiService.js